import { SET_TITLE_PRIVATE_FUNCTIONS } from "./TitlePrivateFunctionAction";

const initialState = {
    data: {}
};

const titlePrivateFunctionsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_TITLE_PRIVATE_FUNCTIONS:
            return { data: action.payload };    
        default:
            return state;
    }
}

export default titlePrivateFunctionsReducer;